import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { MapPin, Navigation, Trees } from "lucide-react";
import { api } from "@/lib/api";
import RecMap from "@/components/guest/RecMap";

export default function PicnicMap() {
  const { id } = useParams();
  const [addon, setAddon] = useState(null);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    api.get(`/addons/${id}`)
      .then((r) => { setAddon(r.data); setStatus("ok"); })
      .catch(() => setStatus("error"));
  }, [id]);

  const spots = (addon?.map_spots || []).filter((s) => typeof s.latitude === "number" && typeof s.longitude === "number");

  if (status === "loading") {
    return <div className="min-h-screen flex items-center justify-center bg-brand-bg text-brand-forest/60">Loading…</div>;
  }
  if (status === "error" || spots.length === 0) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-brand-bg text-center px-6" data-testid="picnic-map-empty">
        <div>
          <Trees size={40} className="mx-auto text-brand-terracotta mb-4" />
          <p className="font-display text-2xl text-brand-forest">No picnic spots yet</p>
          <p className="text-brand-forest/60 mt-2">This map isn't available. Please check with your host.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-brand-bg" data-testid="picnic-map-page">
      <div className="bg-brand-forest text-white">
        <div className="max-w-4xl mx-auto px-6 py-12 text-center">
          <Trees size={36} className="mx-auto text-brand-terracotta mb-4" />
          <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight" data-testid="picnic-map-title">Top 10 Picnic Spots</h1>
          <p className="text-white/70 mt-3 max-w-xl mx-auto">In &amp; around Apache Junction — from Canyon &amp; Saguaro Lakes to the Superstition foothills.</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8 sm:py-10 space-y-8">
        <RecMap items={spots} />

        <div className="grid sm:grid-cols-2 gap-4">
          {spots.map((s, i) => (
            <div key={i} data-testid={`picnic-spot-${i}`} className="bg-white rounded-2xl p-5 border border-black/5 shadow-sm flex flex-col">
              <div className="flex items-start gap-2.5">
                <span className="mt-0.5 h-7 w-7 shrink-0 rounded-full bg-brand-terracotta text-white flex items-center justify-center text-sm font-semibold">{i + 1}</span>
                <div className="flex-1">
                  <h3 className="font-display text-lg tracking-tight flex items-center gap-1.5"><MapPin size={15} className="text-brand-terracotta" />{s.title}</h3>
                  {s.description && <p className="text-sm text-brand-forest/70 mt-1 leading-relaxed">{s.description}</p>}
                </div>
              </div>
              <a
                href={`https://maps.google.com/?q=${s.latitude},${s.longitude}`}
                target="_blank" rel="noreferrer"
                data-testid={`picnic-directions-${i}`}
                className="mt-3 self-start inline-flex items-center gap-1.5 text-sm font-medium text-brand-terracotta hover:underline"
              >
                <Navigation size={14} /> Get directions
              </a>
            </div>
          ))}
        </div>
        <p className="text-center text-xs text-brand-forest/40 pt-2">MyAZbnb.com</p>
      </div>
    </div>
  );
}
